import styled from "@emotion/styled"
import {
  border,
  color,
  flexbox,
  background,
  layout,
  space,
  variant,
  system,
  BorderProps,
  BackgroundProps,
  ColorProps,
  LayoutProps,
  SpaceProps,
  AlignItemsProps,
  AlignContentProps,
  JustifyItemsProps,
  JustifyContentProps,
} from "styled-system"

import { theme } from "../theme"

type BoxProps = LayoutProps &
  SpaceProps &
  BorderProps &
  ColorProps &
  BackgroundProps

export const Box = styled.div<BoxProps>`
  ${border}
  ${layout}
  ${space}
  ${color}
  ${background}
`

const gaps = system({
  gap: {
    property: "gap",
    scale: "gap",
    defaultScale: [2, 4, 8, 16, 24, 32, 48],
  },
})

type GapsProps = {
  gap?: number
}

const flexVariants = {
  variants: {
    centered: {
      placeItems: "center",
      placeContent: "center",
    },
  },
}

type FlexVariantProps = {
  variant?: keyof typeof flexVariants.variants
}

type StackAndRowProps = AlignItemsProps &
  AlignContentProps &
  JustifyItemsProps &
  JustifyContentProps &
  BoxProps &
  FlexVariantProps &
  GapsProps
type StackProps = StackAndRowProps

export const Stack = styled(Box) <StackProps>`
  ${flexbox}
  ${gaps}
  ${variant(flexVariants)}
  width: 100%;
  display: flex;
  flex-direction: column;
`

type RowProps = StackAndRowProps

export const Row = styled(Box) <RowProps>`
  ${flexbox}
  ${gaps}
  ${variant(flexVariants)}
  align-items: center;
  display: flex;
  flex-direction: row;
`

export const Button = styled.button`
  background-color: ${theme.colors.primary};
  border-radius: 1000px;
  padding: 10px 15px;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  cursor: pointer;
  letter-spacing: 1.2px;
  border: none;
`

export const ButtonGhost = styled.button`
  background-color: ${theme.colors.subwhite};
  border-radius: 1000px;
  padding: 10px 15px;
  color: ${theme.colors.black};
  font-weight: regular;
  font-size: 14px;
  cursor: pointer;
  letter-spacing: 1.2px;
  border: none;
`
export const ButtonGhostWide = styled(ButtonGhost)`
  width: 100%;
  padding: 16px;
`
export const ButtonWide = styled(Button)`
  width: 100%;
  padding: 16px;
`
